import { render, staticRenderFns } from "./sisSortableTable.vue?vue&type=template&id=1bc2c93f&lang=pug&"
import script from "./sisSortableTable.vue?vue&type=script&lang=js&"
export * from "./sisSortableTable.vue?vue&type=script&lang=js&"
import style0 from "./sisSortableTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports